import React, {CSSProperties} from "react";
import {WelcomeConfiguration} from "../models/Models";

interface WelcomeViewProps {
    welcomeConfig: WelcomeConfiguration | undefined;
}

const containerStyle: CSSProperties = {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
};

const imageStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
};

/** Shorter texts are written larger, so a short greeting fills the screen and a long one still fits. */
function getTextFontSize(text: string): string {
    if (text.length <= 40) return 'clamp(2rem, 7vw, 10rem)';
    if (text.length <= 120) return 'clamp(1.5rem, 4.5vw, 6rem)';
    return 'clamp(1.25rem, 3vw, 4rem)';
}

/**
 * Fills the screen below the header with the uploaded image, or with the configured text when no image
 * is set. The image address only changes when a new image is uploaded and the endpoint lets the browser
 * cache it for good, so every screen downloads each image once — the data set pushed every few seconds
 * only carries its id.
 */
const WelcomeView: React.FC<WelcomeViewProps> = ({welcomeConfig}) => {
    const imageFileDataId = welcomeConfig?.imageFileDataId;

    if (welcomeConfig && imageFileDataId) {
        return <div style={containerStyle}>
            <img
                key={imageFileDataId}
                src={`${process.env.REACT_APP_API_LOCATION}/api/public/events/${welcomeConfig.eventId}/liveimages/${imageFileDataId}`}
                alt={welcomeConfig.text ?? ''}
                decoding="async"
                style={imageStyle}
            />
        </div>;
    }

    const text = welcomeConfig?.text ?? '';
    return <div style={{...containerStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4vh 4vw'}}>
        <div style={{
            fontSize: getTextFontSize(text),
            fontWeight: 700,
            lineHeight: 1.15,
            textAlign: 'center',
            whiteSpace: 'pre-line',
            overflowWrap: 'anywhere'
        }}>
            {text}
        </div>
    </div>;
}

export default WelcomeView;
